import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './LandingPage.css';

// Carousel images from public folder
const images = [
  `${process.env.PUBLIC_URL}/carousel3.jpg`,
  `${process.env.PUBLIC_URL}/carousel4.jpg`,
];

const serviceItems = [
  {
    key: 'bachelor',
    label: 'Bachelor/Bachelorette Security',
    text: 'Celebrate boldly — we’ve got you covered from pregame to after-hours.',
    bg: `${process.env.PUBLIC_URL}/bachelor.jfif`,
  },
  {
    key: 'vip',
    label: 'VIP Event Coverage',
    text: 'From red carpets to rooftop parties, we move with you — quietly and confidently.',
    bg: `${process.env.PUBLIC_URL}/vip.jfif`,
  },
  {
    key: 'nightlife',
    label: 'Day & Nightlife Protection',
    text: 'Explore Vegas without limits. Our team shadows you with precision and discretion.',
    bg: `${process.env.PUBLIC_URL}/nightlife.jfif`,
  },
  {
    key: 'influencer',
    label: 'Influencer & Executive Protection',
    text: 'High-profile presence. Low-profile protection — so you can shine without compromise.',
    bg: `${process.env.PUBLIC_URL}/influencer.jfif`,
  },
];

const LandingPage: React.FC = () => {
  const { login } = useAuth();
  const [currentImage, setCurrentImage] = useState(0);
  const [hoveredKey, setHoveredKey] = useState<string | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='landing-page'>
      <section className='hero'>
        <div className='hero-carousel'>
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt='Vegas Scene'
              className={`hero-image ${index === currentImage ? 'active' : ''}`}
            />
          ))}
        </div>
        <div className='titles'>
          <h2>Live Loud. Stay SAëF.</h2>
          <p>
            We don’t just provide protection—we curate peace of mind. Connect you to elite, discreet
            security services tailored to your lifestyle, so you can experience Las Vegas with
            confidence, freedom, and style.
          </p>
          <div className='buttons'>
            <button onClick={login}>Book Now</button>
          </div>
        </div>
      </section>

      <section className='about' id='about'>
        <h3>You live boldly — we handle the details.</h3>
        <p>
          SAëF is a luxury concierge service reimagined—delivering tailored experiences and elite
          protection at your fingertips...
        </p>
      </section>

      <section className='services' id='services'>
        <p className='service-intro'>Your Protection. Your Timing. Your Way.</p>
        <div className='service-list'>
          {serviceItems.map((item) => (
            <div
              key={item.key}
              className='service-item'
              onMouseEnter={() => setHoveredKey(item.key)}
              onMouseLeave={() => setHoveredKey(null)}
            >
              <div
                className='hover-image-overlay'
                style={{
                  backgroundImage: `url(${item.bg})`,
                  // opacity: hoveredKey === item.key ? 1 : 0,
                }}
              ></div>
              <div className='service-item-content'>
                <h4 className='service-item-label'>{item.label}</h4>
                <br />
                <p className='service-item-text'>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
        <p className='booking-note'>
          Whether it's planned weeks in advance or a last-minute need...
        </p>
        <div className='book-button-wrapper'>
          <button className='book-button' onClick={login}>
            Book Now
          </button>
        </div>
      </section>

      <section className='testimonials' id='testimonials'>
        <h3>Trusted by Those Who Move Loudest</h3>
        <blockquote>"SAëF made our Vegas bachelorette weekend unforgettable..."</blockquote>
        <blockquote>"I’m an influencer and privacy is everything..."</blockquote>
      </section>

      <footer>
        &copy; 2025 SAëF | Serving Las Vegas with excellence and discretion.
        <div className='footer-links'>
          <a href='https://instagram.com' target='_blank' rel='noopener noreferrer'>
            Instagram
          </a>
          <a href='https://facebook.com' target='_blank' rel='noopener noreferrer'>
            Facebook
          </a>
          <a href='https://twitter.com' target='_blank' rel='noopener noreferrer'>
            Twitter
          </a>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
